var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, DRIVE_EXTERNAL_SHARE_SEARCH, navigateChartPeriodBarClick } from '@web/utility/chartNavigation';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { diffComparisonType } from '@workalizer/shared/types';
import { getInterval, getPercentageDiff } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var DOCS_SHARED_EXTERNALLY_TEAM_STRIPE_PATTERN_ID = "".concat(InsightTypeEnum.docsSharedExternally, "_teamAverage");
export var DocsSharedExternally = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = trpc.docsSharedExternally.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    var interval = getInterval(dateFrom, dateTo);
    var handleBarClick = function (barData, fallbackIndex, stack, teamScope) {
        if (teamScope === void 0) { teamScope = false; }
        if (!data) {
            return;
        }
        navigateChartPeriodBarClick({
            chartData: data.periods,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: stack,
            destination: __assign({ kind: 'driveAdvancedSearch' }, DRIVE_EXTERNAL_SHARE_SEARCH),
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: teamScope ? null : userId,
            orgUnitId: orgUnitId
        });
    };
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var docsSharedMetricLabel = t('tooltip.metrics.docsSharedExternally');
    var docsSharedSeriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter({
        docsSharedExternally: docsSharedMetricLabel,
        previousPeriod: docsSharedMetricLabel,
        teamAverage: docsSharedMetricLabel,
        periodBar: docsSharedMetricLabel
    });
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: data.periods.length,
        barsPerGroup: userId ? 3 : 2
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(data.periods);
    var legendItems = __spreadArray([
        {
            key: 'docsSharedExternally',
            currentValue: data.totals.docsSharedExternally,
            diffValue: getPercentageDiff(data.totals.previousPeriod, data.totals.docsSharedExternally),
            teamAverage: userId
                ? getPercentageDiff(data.totals.teamAverage, data.totals.docsSharedExternally, { comparisonType: diffComparisonType.teamAverage })
                : undefined
        },
        {
            key: 'previousPeriod',
            currentValue: data.totals.previousPeriod
        }
    ], (userId
        ? [
            {
                key: 'teamAverage',
                currentValue: data.totals.teamAverage
            }
        ]
        : []), true);
    var docsSharedSeriesKeys = legendItems.map(function (_a) {
        var key = _a.key;
        return key;
    });
    var getDocsSharedPeriodDiff = function (dataKey, row) {
        var _a, _b;
        if (dataKey !== 'docsSharedExternally' || !row) {
            return undefined;
        }
        return getPercentageDiff(Number((_a = row.previousPeriod) !== null && _a !== void 0 ? _a : 0), Number((_b = row.docsSharedExternally) !== null && _b !== void 0 ? _b : 0));
    };
    var getDocsSharedTeamDiff = function (dataKey, row) {
        var _a, _b;
        if (!userId || dataKey !== 'docsSharedExternally' || !row) {
            return undefined;
        }
        return getPercentageDiff(Number((_a = row.teamAverage) !== null && _a !== void 0 ? _a : 0), Number((_b = row.docsSharedExternally) !== null && _b !== void 0 ? _b : 0), { comparisonType: diffComparisonType.teamAverage });
    };
    var renderDocsSharedExternallyTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: __spreadArray([
            'previousPeriod',
            'docsSharedExternally'
        ], (userId ? ['teamAverage'] : []), true), periodComparisonTooltip: true, seriesLabelFormatter: docsSharedSeriesLabelFormatter, formatValue: function (value) { return value.toString(); }, getPeriodDiff: getDocsSharedPeriodDiff, getTeamDiff: userId ? getDocsSharedTeamDiff : undefined, periodDiffArrowColor: TablesDiffColorsConfig.GREEN, stripeSwatchColors: userId
            ? {
                teamAverage: NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG.teamAverage
                    .chartColor
            }
            : undefined }), data.periods.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.sharedExternally'), description: t('widgetTitleDescriptions.policyCompliance.sharedExternally'), insightType: InsightTypeEnum.docsSharedExternally, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.sharedExternally'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, ((_a = data.periods) !== null && _a !== void 0 ? _a : []).map(function (period) {
                                    var _a;
                                    var row = (_a = {},
                                        _a[t('filters.period')] = period.period,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.docsSharedExternally')] = period.docsSharedExternally,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.previousPeriod')] = period.previousPeriod,
                                        _a);
                                    if (userId) {
                                        row[t('export.teamAverage')] = period.teamAverage;
                                    }
                                    return row;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: docsSharedSeriesKeys }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "flex gap-8 lg:gap-8 mb-6 p-4 ml-2 rounded-lg justify-start flex-wrap" }, { children: legendItems.map(function (_a) {
                                    var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                    var barConfig = NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG[key];
                                    return (_jsx(LegendItem, { color: barConfig.color, label: t("app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.".concat(barConfig.translationKey)), currentValue: currentValue, diffValue: key === 'docsSharedExternally' ? diffValue : undefined, teamAverage: key === 'docsSharedExternally' ? teamAverage : undefined, arrowColor: TablesDiffColorsConfig.GREEN, stripeChartColor: userId && key === 'teamAverage'
                                            ? NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG
                                                .teamAverage.chartColor
                                            : undefined, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: data.periods, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [userId &&
                                                rechartsDiagonalStripePatternDefs([
                                                    {
                                                        patternId: DOCS_SHARED_EXTERNALLY_TEAM_STRIPE_PATTERN_ID,
                                                        chartColor: NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG
                                                            .teamAverage.chartColor
                                                    }
                                                ]), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderDocsSharedExternallyTooltip }), _jsx(Bar, { dataKey: "previousPeriod", fill: NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG
                                                    .previousPeriod.chartColor, stackId: "previous", radius: [4, 4, 4, 4], onClick: function (barData, index) {
                                                    return handleBarClick(barData, index, ComparisonPeriod.Previous);
                                                }, style: { cursor: 'pointer' }, hide: !isSeriesVisible('previousPeriod') }), _jsx(Bar, { dataKey: "docsSharedExternally", fill: NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG
                                                    .docsSharedExternally.chartColor, stackId: "current", radius: [4, 4, 4, 4], onClick: function (barData, index) {
                                                    return handleBarClick(barData, index, ComparisonPeriod.Current);
                                                }, style: { cursor: 'pointer' }, hide: !isSeriesVisible('docsSharedExternally') }), userId && (_jsx(Bar, { dataKey: "teamAverage", fill: rechartsDiagonalStripeFillUrl(DOCS_SHARED_EXTERNALLY_TEAM_STRIPE_PATTERN_ID), stackId: "team", radius: [4, 4, 4, 4], onClick: function (barData, index) {
                                                    return handleBarClick(barData, index, ComparisonPeriod.Current, true);
                                                }, style: { cursor: 'pointer' }, hide: !isSeriesVisible('teamAverage') }))] })) })) }))] })));
                } }))] })));
};
